import { render, staticRenderFns } from "./Governance.vue?vue&type=template&id=5e8a9fb3&scoped=true&"
import script from "./Governance.vue?vue&type=script&lang=js&"
export * from "./Governance.vue?vue&type=script&lang=js&"
import style0 from "./Governance.vue?vue&type=style&index=0&id=5e8a9fb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a9fb3",
  null
  
)

export default component.exports